module.exports = __webpack_public_path__ + "files/d11acb123caa9cf00459091e866d3245.png";